


















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/partenaire/edit/EditFlux.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { AloPartenaire, getDefaultAloPartenaire } from '@/models/alo/AloPartenaire'

@Component({
  name: 'ReadFlux',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    partenaire:{
      type:Object,
      default:getDefaultAloPartenaire
    },
    editable:{
      type:Boolean,
      default:true      
    }
  }
})
export default class ReadFlux extends Vue {
  
  private partenaire!:AloPartenaire
  private loading!:boolean

  get flux(){
    return this.$store.myGetters.flux
  } 

  edit() { (this.$refs.edit as Edit).edit(this.partenaire) }

}
